module.exports = __webpack_public_path__ + "static/bubbles1-4925a797a3c8ef3613de9db6e3db5744.mp4";